import { useState } from "react";
import { IoClose } from "react-icons/io5";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog/alert-dialog";
import { cn } from "@/lib/utils";

export type Attendance = {
  status: string;
  date: string | Date;
  id: string;
  checkinTime: string;
  checkoutTime: string;
  hoursWorked: number;
};

interface Props {
  attendance: Attendance;
}

const ATTENDANCE_COLORS: {
  [key: string]: string;
} = {
  "Half-day": "#FFFF00",
  Present: "#00FF00",
  Absent: "#FF0000",
  "Paid Leave": "#00CED1",
  "On Leave": "#FFA500",
  "Not Counting": "#808080",
};

const ATTENDANCE_FOREGROUNDS: {
  [key: string]: string;
} = {
  "Half-day": "black",
  Present: "black",
  Absent: "black",
  "Paid Leave": "black",
  "On Leave": "black",
  "Not Counting": "black",
};

export const AttendanceEvent = ({ attendance }: Props) => {
  const [open, setOpen] = useState(false);

  const colorAtt = ATTENDANCE_FOREGROUNDS[attendance.status];
  const bgAtt = ATTENDANCE_COLORS[attendance.status];

  return (
    <div>
      <div
        style={{
          backgroundColor: bgAtt,
          color: colorAtt,
        }}
      >
        <AlertDialog open={open} onOpenChange={setOpen}>
          <AlertDialogTrigger className="tracking-normal">
            <div
              className={cn(
                "flex items-center justify-between px-3 py-2",
                colorAtt
              )}
            >
              <div>{attendance?.status}</div>
            </div>
          </AlertDialogTrigger>
          <AlertDialogContent className={cn("transition-all duration-300")}>
            <AlertDialogCancel className="absolute right-2 top-2 h-7 w-7 p-0 border-none">
              <IoClose className="w-5 h-5" />
            </AlertDialogCancel>
            <AlertDialogHeader>
              <AlertDialogTitle>Attendance</AlertDialogTitle>
            </AlertDialogHeader>

            <div className="flex">
              <div className="flex flex-col p-3 shrink-0">
                <h5>
                  <span>Attendance Marking : </span>
                  <span className="font-semibold">{attendance?.status}</span>
                </h5>
                <h5 className="mt-1">
                  <span>Hours worked : </span>
                  <span className="font-semibold">
                    {attendance?.hoursWorked}
                  </span>
                </h5>
                <h5 className="mt-1">
                  <span>Checkin Time : </span>
                  <span className="font-semibold">
                    {attendance?.checkinTime}
                  </span>
                </h5>
                <h5 className="mt-1">
                  <span>Checkout Time : </span>
                  <span className="font-semibold">
                    {attendance?.checkoutTime}
                  </span>
                </h5>
              </div>
            </div>
          </AlertDialogContent>
        </AlertDialog>
      </div>

      <div className="bg-white flex flex-col text-black px-1 max-w-full flex-wrap">
        <p className="text-[11px]">Checkin - {attendance?.checkinTime}</p>
        <p className="text-[11px]">Checkout - {attendance?.checkoutTime}</p>
        {/* <p className="text-[11px]">Hours - {attendance?.hoursWorked}</p> */}
      </div>
    </div>
  );
};
